import React from 'react';

import { LogoContainer } from './Logo.styles';
import simple from '../../../assets/logos/simple.svg';
import composite from '../../../assets/logos/composite.svg';
import ca from '../../../assets/logos/ca.svg';
import cie from '../../../assets/logos/cie.svg';
import ocr from '../../../assets/logos/ocr.svg';
import caPress from '../../../assets/logos/caPress.svg';

export interface LogoProps {
  children?: React.ReactElement | React.ReactNode;
  className?: string;
  dataQaId?: string;
  height?: number | string;
  width?: number | string;
  type?: 'simple' | 'composite' | 'cie' | 'ocr' | 'ca' | 'caPress';
  alt?: string;
}

const Logo: React.FC<LogoProps> = ({
  children,
  className,
  dataQaId,
  height,
  width,
  type = 'ca',
  alt = 'Cambridge Logo',
}: LogoProps) => {
  const renderPlaceholder = () => {
    const logos = {
      simple,
      composite,
      cie,
      ocr,
      ca,
      caPress,
    };

    return <img src={logos[type]} alt={alt} />;
  };

  return (
    <LogoContainer className={className} data-qa-id={dataQaId} height={height} width={width}>
      {children ? children : renderPlaceholder()}
    </LogoContainer>
  );
};

export default Logo;
